// extracted by mini-css-extract-plugin
export default {"inputWrapper":"MUIFieldWithoutControl_inputWrapper__WD9cG","clearBtn":"MUIFieldWithoutControl_clearBtn__Npb+r"};